import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import styles from './styles.module.scss';

class BackButton extends React.Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    if(this.props.onClick){
      this.props.onClick()
    }
  }
  render() {
    const { className } = this.props
    return (
      <button className={cx(styles.button, className)} onClick={this.handleClick}>
        <i className="paperflite-left-arrow" aria-hidden="true"></i>
        <span className={styles.title}>{this.props.title}</span>
      </button>
    );
  }

}

export default BackButton;
